import React from 'react';
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './EditFieldForm.scss';
import { Tooltip } from './Tooltip';

export const EditFieldForm = ({ fieldProp,
  isEditingFieldProp, editingFieldCallback, hoverCallback }) => {
  const [fieldValue, setFieldValue] = useState(fieldProp);
  const wrapperRef = useRef(null);

  const onFieldChangeSubmit = (e) => {
    e.preventDefault();
    if (fieldValue !== fieldProp) {
      editingFieldCallback(fieldValue, true);
    } else {
      editingFieldCallback(fieldValue, false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onFieldChangeSubmit(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, fieldValue]);

  useEffect(() => setFieldValue(fieldProp), [fieldProp]);

  if (isEditingFieldProp) {
    return (<form onSubmit={onFieldChangeSubmit} ref={wrapperRef}>
      <input type="text"
        placeholder={fieldValue}
        value={fieldValue}
        onChange={(e) => setFieldValue(e.target.value)}
      />
    </form>);
  }
  return (
    <Tooltip textContent={fieldValue}>
      <p
        className='editFieldForm'
        onMouseEnter={() => hoverCallback(true)}
        onMouseLeave={() => hoverCallback(false)}>
        {fieldValue}
      </p>
    </Tooltip>
  );
};

EditFieldForm.propTypes = {
  fieldProp: PropTypes.string,
  isEditingFieldProp: PropTypes.bool,
  editingFieldCallback: PropTypes.func,
  hoverCallback: PropTypes.func,
};
